<template>
  <div id="app">
    <!-- <keep-alive> -->
    <router-view />
    <!-- </keep-alive> -->
  </div>
</template>

<script>
export default {
  name: "App",
    provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    
  },
   methods: {
    // 刷新页面
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
  },
};
</script>
<style lang="scss">
@import "./styles/reset";

[v-cloak] {
  display: none;
}

#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/* 全局设置 element ui dialog水平垂直居中 */
.el-dialog {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0px !important;
}
.button-small {
  width: 98px;
  height: 32px;
  line-height: 32px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  float: left;
}

.switchStyle {
	height: 24px;
	line-height: 24px;
	.el-switch__label {
		width: 50px !important;
		height: 24px !important;
		position: absolute;
		border-radius: 15px;
		display: none;
		color: #fff;
		font-family: SourceHanSansCN, SourceHanSansCN;
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		font-style: normal;
		&--left {
			z-index: 9;
			left: 28px;
		}
			

		&--right {
			z-index: 9;
			left: 0px;
		}

		&.is-active {
			display: block;
		}	
	}
	.el-switch__core {
		width: 50px !important;
		height: 24px !important;
		border-radius: 15px;
		&::after {
			top: 1px;
			width: 20px;
			height: 20px;
			border-radius: 15px;
		}
	}
	&.is-checked {
		.el-switch {
			&__core {
				&::after {
					margin-left: -20px;
				}
			}
		}
	}
}
</style>
